<template>
  <div class="step-container">
    <div class="steps">
      <div class="step step1" :class="{'active': step1}"></div>
      <div class="step step2" :class="{'active': step2}"></div>
      <div class="step step3" :class="{'active': step3}"></div>
      <div class="step step4" :class="{'active': step4}"></div>
    </div>
    <div class="lines">
      <div class="line"></div>
      <div class="line"></div>
      <div class="line"></div>
    </div>
    <div class="texts">
      <div class="text first">QQ和手机验证</div>
      <div class="text">邮箱验证</div>
      <div class="text">邮箱激活</div>
      <div class="text last">完成</div>
    </div>
  </div>
</template>

<script>
// import store from '@/store';
export default {
  props: ['step'],
  data() {
    return {
      step1: true,
      step2: false,
      step3: false,
      step4: false
    };
  },
  mounted() {
    if (this.step === 4) {
      this.step1 = true;
      this.step2 = true;
      this.step3 = true;
      this.step4 = true;
    }
    if (this.step === 2) {
      this.step1 = true;
      this.step2 = true;
    }
    if (this.step === 3) {
      this.step1 = true;
      this.step2 = true;
      this.step3 = true;
    }
  }
};
</script>

<style lang="less">
.step-container{
  position: relative;
  height: 224px;
  width: 963px;
  .lines{
    position: absolute;
    width: 800px;
    top: 100px;
    left: 105px;
    font-size: 0px;
    .line{
      display: inline-block;
      width: 124px;
      height: 1px;
      background: #bfbfbf;
      margin: 0 63px;
    }
  }
  .steps{
    width: 100%;
    padding-top: 55px;
    font-size: 0px;
    .step{
      font-size: 20px;
      display: inline-block;
      width: 25%;
      height: 90px;
      &.step1, &.step2, &.step3, &.step4{
        background-repeat: no-repeat;
        background-position: center;
      }
      &.step1{
        background-image: url(./img/icon_step1_selected.png);
        background-position: 55px center;
        &.active{
          background-image: url(./img/icon_step1_selected.png);
        }
      }
      &.step2{
        background-image: url(./img/icon_step2_normal.png);
        &.active{
          background-image: url(./img/icon_step2_selected.png);
        }
      }
      &.step3{
        background-image: url(./img/icon_step3_normal.png);
        &.active{
          background-image: url(./img/icon_step3_selected.png);
        }
      }
      &.step4{
        background-image: url(./img/icon_step4_normal.png);
        background-position: 85px center;
        &.active{
          background-image: url(./img/icon_step4_selected.png);
        }
      }
    }
  }
  .texts{
    height: 20px;
    line-height: 20px;
    margin-top: 18px;
    text-align: center;
    color: #666666;
    font-size: 0px;
    .text{
      font-size: 20px;
      display: inline-block;
      height: 20px;
      width: 25%;
      line-height: 20px;
      &.first{
        text-align: left;
        padding-left: 35px;
      }
      &.last{
        padding-left: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/validate/common/StepHeader.vue